import React, { useMemo, useState } from 'react'
import './shipping.css'
import camera from '../../../assets/svgs/camera.svg'
import Compressor from 'compressorjs'
import { showApiError } from '../../../common/message'
import { Button, Image, message, Space, Upload } from 'antd'
import type { UploadProps } from 'antd'

type Props = {
  photo?: string
  onSelect: (image: File) => void
  disabled?: boolean
  className?: string
}
const ShippingPhoto = ({ photo, disabled, onSelect, className }: Props) => {
  const [image, setImage] = useState<File>()
  const previewImage = useMemo(() => (image ? URL.createObjectURL(image) : photo), [image, photo])
  const [messageApi, messageHolder] = message.useMessage()

  const handleUpload = (file: File) => {
    if (file?.size >= 1000000) {
      let quality = 0.1
      if (file.size < 10000000) {
        quality = 1 - file.size / 10000000
      }
      //1Gb
      new Compressor(file, {
        quality,
        convertSize: 1000000,
        // The compression process is asynchronous,
        // which means you have to access the `result` in the `success` hook function.
        success(blob) {
          const file: File = blob as File
          setImage(file)
          onSelect(file)
        },
        error: (error) => showApiError(error, messageApi),
      })
    } else {
      setImage(file)
      onSelect(file)
    }
  }

  const uploadProps: UploadProps = {
    accept: 'image/*',
    showUploadList: false,
    beforeUpload: (file) => {
      handleUpload(file as File)
      return false
    },
    disabled,
  }

  return (
    <Space direction={'horizontal'} size={10} className={className}>
      {messageHolder}
      <Upload {...uploadProps}>
        <Button
          className={'delivery-complete-image delivery-upload-trigger'}
          icon={<img alt={'camera'} src={camera} className={'delivery-camera'} />}
          disabled={disabled}
        />
      </Upload>
      {previewImage && (
        <Image
          src={previewImage}
          width={76}
          height={76}
          alt={'delivery preview'}
          loading={'lazy'}
          className={disabled ? 'delivery-preview delivery-preview-disabled' : 'delivery-preview'}
        />
      )}
    </Space>
  )
}

export default ShippingPhoto
